/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M46.36 4.84a2.2 2.2 0 0 1 0 3.12l-21.9 22c-.86.85-2.25.85-3.1 0l-6.58-6.6a2.2 2.2 0 0 1 0-3.12 2.18 2.18 0 0 1 3.1 0l5.02 5.05L43.26 4.84a2.18 2.18 0 0 1 3.1 0z"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M7.57 6.4a2.19 2.19 0 0 0-2.19 2.2v30.8a2.2 2.2 0 0 0 2.2 2.2h30.66a2.19 2.19 0 0 0 2.19-2.2V24a2.2 2.2 0 1 1 4.38 0v15.4a6.61 6.61 0 0 1-6.57 6.6H7.57A6.56 6.56 0 0 1 1 39.4V8.6A6.61 6.61 0 0 1 7.57 2h24.1a2.2 2.2 0 0 1 0 4.4H7.57z"/>'
  }
})
